import { Box, Grid } from "@mui/material";
import { useState } from "react";
import NunitoText from "../general/NunitoText";
import ReusableButton from "../general/ReusableButton";
import ReusableCheckbox from "../general/ReusableCheckbox";

export default function PatchMarkingOptionsModal({
  markedManually,
  confirmFunction,
  cancelConfirm,
}) {
  const [checkAll, setCheckAll] = useState(true);
  // const [clearPrevious, setClearPrevious] = useState(false);
  const [remark, setRemark] = useState(false);
  const [checkboxes, setCheckboxes] = useState([
    {
      name: "country_rank",
      label: "Country Rank",
      checked: true,
    },
    {
      name: "school_rank",
      label: "School Rank",
      checked: true,
    },
    {
      name: "award",
      label: "Award",
      checked: true,
    },
    {
      name: "global_rank",
      label: "Global Rank",
      checked: true,
    },
  ]);

  const handleCheckboxChange = (index) => {
    // console.log(index);
    const updatedCheckboxes = [...checkboxes];
    updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;

    // //condition to check if Global Rank is checked then make Award checked also
    // if (index === 3 && updatedCheckboxes[index].checked) {
    //   updatedCheckboxes[2].checked = true;
    // }

    // //condition to check if Award is unchecked then make Global Rank unchecked also
    // if (index === 2 && !updatedCheckboxes[index].checked) {
    //   updatedCheckboxes[3].checked = false;
    // }

    setCheckboxes(updatedCheckboxes);

    // Check if all checkboxes are checked
    const allChecked = updatedCheckboxes.every((checkbox) => checkbox.checked);
    setCheckAll(allChecked);
  };

  const handleCheckAllChange = (event) => {
    const newCheckAll = !checkAll;
    setCheckAll(newCheckAll);

    // Update the state of all checkboxes based on the newCheckAll value
    const updatedCheckboxes = checkboxes.map((checkbox) => ({
      ...checkbox,
      checked: newCheckAll,
    }));
    setCheckboxes(updatedCheckboxes);
  };

  const handleConfirm = () => {
    confirmFunction(false, [
      {
        name: "remark",
        label: "Remark",
        checked: markedManually === 0 ? remark : false,
      },
      ...checkboxes,
    ]);
  };

  return (
    <Box
      className="popUpModal"
      style={{
        width: 705,
        minHeight: 310,
        position: "fixed",
        top: "50%",
        right: "50%",
        zIndex: 1000,
      }}
    >
      <NunitoText
        value="Marking and Computation of results"
        fontSize={30}
        fontWeight={600}
        color="var(--color-primary)"
        marginTop={30}
      />
      <NunitoText
        value={`Please indicate other computational tasks required besides marking`}
        fontSize={20}
        fontWeight={600}
      />
      <Grid
        container
        spacing={2}
        columns={{ xs: 4 }}
        style={{
          margin: "30px 40px 20px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <Grid
          item
          xs={4}
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <ReusableCheckbox
            type="modal"
            label={"Clear previous results"}
            fontSize="24px"
            state={clearPrevious}
            setState={setClearPrevious}
          />
        </Grid> */}
        {/* <Grid
          item
          xs={2}
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <ReusableCheckbox
            type="modal"
            label={"All"}
            fontSize="24px"
            state={checkAll}
            setState={handleCheckAllChange}
          />
        </Grid> */}
        {markedManually === 0 && (
          <Grid
            item
            xs={4}
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <ReusableCheckbox
              type="modal"
              label={"Re-mark"}
              fontSize="24px"
              state={remark}
              setState={setRemark}
            />
          </Grid>
        )}
        {remark && (
          <Grid
            item
            xs={4}
            style={{
              marginTop: "-20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              fontSize: 15,
            }}
          >
            <div style={{ color: "var(--color-danger)" }}>Attention!!</div>
            <div>
              If the moderation process for the results has already been
              successfully completed.
            </div>
            <div>
              You need to do your award and moderation again if you want to
              proceed with re-marking!
            </div>
            <div>
              <span style={{ color: "var(--color-danger)" }}>Note:</span>
              You may also need to do the school and country ranking again if
              they are completed.
            </div>
          </Grid>
        )}
        {checkboxes.map(({ label, checked }, index) => {
          return (
            <Grid
              item
              xs={2}
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
              key={index}
            >
              <ReusableCheckbox
                type="modal"
                label={label}
                fontSize="24px"
                state={checked}
                setState={() => handleCheckboxChange(index)}
              />
            </Grid>
          );
        })}
      </Grid>

      <Grid
        container
        justifyContent="space-evenly"
        style={{ marginBlock: "30px 20px" }}
      >
        <ReusableButton
          text="Cancel"
          bgColor="var(--color-surface)" color="var(--color-primary)" borderColor="var(--color-border-strong)"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => cancelConfirm()}
        />
        <ReusableButton
          text="Confirm"
          bgColor="var(--color-primary)"
          fontSize={25}
          height={63}
          width={280}
          onClick={handleConfirm}
        />
      </Grid>
    </Box>
  );
}
